var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLunch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.999 511.999",
    style: {
      enableBackground: "new 0 0 511.999 511.999"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#995C0D"
    },
    d: "M400.775,331.434h-19.972v-9.986c0-25.637,20.863-46.495,46.508-46.495h9.986v19.972h-9.986 c-14.632,0-26.536,11.898-26.536,26.523V331.434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2BA5F7"
    },
    d: "M342.657,508.306c5.233,2.33,10.838,3.528,16.484,3.689H177.861 c19.932,0-50.716-194.927-50.716-194.927l-11.064-153.332h245.23c0,0-2.889,51.275-6.95,108.022 c-1.145,15.991-2.383,32.408-3.675,48.239c-0.04,0.479-0.08,0.972-0.12,1.451c-3.209,39.105-6.751,74.402-10.039,90.407 c-10.039,48.825-3.928,93.669,1.638,96.225C342.324,508.159,342.497,508.226,342.657,508.306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2197D8"
    },
    d: "M342.164,508.079c0.16,0.08,0.333,0.146,0.493,0.226c-1.145,0.293-2.277,0.639-3.395,1.039 c-3.635,1.278-7.376,2.104-11.171,2.463c-1.212,0.12-2.437,0.186-3.662,0.186h-1.678c-5.818-0.16-11.597-1.438-16.976-3.915 c-13.155-6.032-23.713-17.149-28.853-31.343l-17.203-47.613c-18.92-52.38,19.892-107.676,75.587-107.676h15.259 c-3.209,39.105-6.751,74.402-10.039,90.407C330.487,460.679,336.599,505.523,342.164,508.079z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F95428"
    },
    d: "M409.883,321.448c55.709,0,94.508,55.296,75.587,107.676l-17.203,47.613 c-1.425,3.928-3.262,7.643-5.459,11.064c-3.009,4.673-6.684,8.828-10.878,12.343c-3.795,3.195-8.002,5.858-12.516,7.936 c-10.532,4.833-22.568,5.126-33.486,1.265c-2.57-0.905-5.219-1.571-7.882-2.011c-2.397-0.386-4.833-0.586-7.257-0.586 c-5.113,0-10.239,0.865-15.139,2.596c-3.635,1.278-7.376,2.104-11.171,2.463c-1.212,0.12-2.437,0.186-3.662,0.186h-1.678 c-5.819-0.16-11.597-1.438-16.976-3.915c-13.155-6.032-23.713-17.149-28.853-31.343l-17.203-47.613 c-18.92-52.38,19.892-107.676,75.587-107.676h6.058h13.035L409.883,321.448L409.883,321.448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E54728"
    },
    d: "M363.591,476.737l-17.203-47.613c-18.228-50.461,17.129-103.621,69.541-107.447 c-1.993-0.145-4.008-0.229-6.048-0.229h-19.093h-13.035h-6.058c-55.695,0-94.508,55.296-75.587,107.676l17.203,47.613 c5.139,14.193,15.698,25.311,28.853,31.343c5.379,2.477,11.158,3.755,16.976,3.915h1.678c1.225,0,2.45-0.067,3.662-0.186 c3.795-0.359,7.536-1.185,11.171-2.463c4.58-1.618,9.359-2.47,14.14-2.575C377.875,500.511,368.379,489.962,363.591,476.737z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2197D8"
    },
    d: "M354.36,271.757c-1.145,15.991-2.383,32.408-3.675,48.239c-18.414-4.873-31.982-21.663-31.982-41.608 V265.34h13.035c2.117,0,4.194,0.146,6.218,0.439C343.908,266.644,349.461,268.722,354.36,271.757z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AD14B"
    },
    d: "M353.934,265.779c20.851,3.022,36.855,20.957,36.855,42.634v13.035h-13.035 c-23.793,0-43.073-19.28-43.073-43.06V265.34h13.035C349.833,265.34,351.91,265.486,353.934,265.779z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2197D8"
    },
    points: "194.881,163.735 116.081,163.735 140.959,511.994 200.871,511.994 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B27214"
    },
    d: "M184.066,384.652c16.51,0,29.891,13.381,29.891,29.878c0,8.255-3.342,15.725-8.761,21.144 c-5.406,5.406-12.875,8.748-21.13,8.748l-66.533,37.96l-65.961-37.96c-16.51,0-29.891-13.381-29.891-29.891 c0-8.255,3.342-15.711,8.748-21.13c5.419-5.406,12.889-8.748,21.144-8.748l67.292-32.754L184.066,384.652z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#995C0D"
    },
    d: "M106.428,444.422H51.571c-16.51,0-29.891-13.381-29.891-29.891c0-8.255,3.342-15.711,8.748-21.13 c5.419-5.406,12.889-8.748,21.144-8.748h54.856c-8.255,0-15.725,3.342-21.144,8.748c-5.406,5.419-8.748,12.875-8.748,21.13 C76.536,431.041,89.918,444.422,106.428,444.422z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B239"
    },
    d: "M213.957,465.427v10.472c0,19.935-16.161,36.096-36.096,36.096h-0.013H57.776 c-19.935,0-36.096-16.161-36.096-36.096v-10.472c0-11.6,9.404-21.004,21.004-21.004h8.888h132.494h8.888 C204.553,444.422,213.957,453.826,213.957,465.427z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B239"
    },
    d: "M127.145,317.067h33.593c29.392,0,53.219,23.827,53.219,53.219v0.013 c0,7.928-6.426,14.353-14.353,14.353h-15.538H51.571H36.033c-7.928,0-14.353-6.426-14.353-14.353l0,0 c0-29.399,23.833-53.232,53.219-53.232L127.145,317.067L127.145,317.067z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E09B2D"
    },
    d: "M112.632,511.994H57.776c-19.932,0-36.096-16.151-36.096-36.096v-31.476h54.856v31.476 C76.536,495.843,92.7,511.994,112.632,511.994z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E09B2D"
    },
    d: "M129.755,317.067c-29.385,0-53.219,23.833-53.219,53.232v14.353H36.033 c-7.928,0-14.353-6.426-14.353-14.353l0,0c0-29.399,23.833-53.232,53.232-53.232L129.755,317.067L129.755,317.067z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F95428"
    },
    d: "M321.865,118.307l-19.671-3.45l15.911-90.737c1.604-9.15,7.283-16.794,15.578-20.975 c8.295-4.181,17.816-4.194,26.125-0.04l63.318,31.658l-8.932,17.864l-63.319-31.66c-2.61-1.305-5.6-1.3-8.204,0.013 c-2.606,1.313-4.39,3.715-4.893,6.588L321.865,118.307z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E6E6"
    },
    points: "361.311,171.724 361.311,171.711 116.081,171.711 116.081,171.724 94.871,171.724  107.133,106.748 370.271,106.748 382.521,171.724 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CCCCCC"
    },
    points: "180.977,106.748 174.905,171.711 174.905,171.724 116.081,171.711 101.501,171.711  101.501,171.724 94.871,171.724 107.133,106.748 "
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLunch);
export default __webpack_public_path__ + "static/media/lunch.27271a1821db06eb932ed4b183c7bb0a.svg";
export { ForwardRef as ReactComponent };